import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { resetViewAs, useViewAs } from "../viewAs";
import { BANNER_HEIGHT } from "./VersionUpdateBanner";

/**
 * The tell that this tab is viewing as someone else. Filled info blue so it can
 * never be mistaken for the non-production amber the app bar already uses.
 */
const ViewAsBanner = () => {
  const { readOnly, me } = useViewAs();
  if (!readOnly) return null;

  return (
    <Alert
      severity="info"
      variant="filled"
      square
      icon={<VisibilityIcon fontSize="inherit" />}
      action={
        <Button color="inherit" size="small" onClick={resetViewAs}>
          Exit
        </Button>
      }
      sx={{
        minHeight: BANNER_HEIGHT,
        py: 0,
        borderRadius: 0,
        alignItems: "center",
      }}
    >
      Viewing as <strong>{me.name}</strong>
      {me.rep && ` · ${me.rep.name}, ${me.rep.agency_name}`} · read-only. Signed
      in as {me.impersonator.name}.
    </Alert>
  );
};

export default ViewAsBanner;
